import { featureFlags } from "@/config/env";
import http from "@/services/http";

export interface ContactPayload {
  name: string; // 姓名
  wechat_id: string; // 微信号
  company_name: string; // 公司名称
  brand: string; // 品牌
  brand_industry: string; // 品牌行业
  business?: string; // 企业主营业务（可选）
  email: string; // 企业邮箱
  // 保留原有字段以兼容
  phone?: string; // 手机号（可选，保持向后兼容）
  im?: string; // IM账号（可选）
  channel?: string; // 渠道来源（可选）
  website_url?: string; // 品牌官网（可选）
}

export const contactApi = {
  submit: (data: ContactPayload) => {
    // 按后端字段要求进行映射
    // const body = {
    //   name: data.name,
    //   wechat_id: data.wechat_id,
    //   company_name: data.company_name,
    //   brand: data.brand,
    //   brand_industry: data.brand_industry,
    //   business: data.business,
    //   email: data.email,
    //   phone: data.phone,
    //   im: data.im,
    //   channel: data.channel,
    //   website_url: data.website_url,
    // };

    if (featureFlags.enableMock) {
      console.log("=== 用户提交联系表单 2===");
      // 轻量内置 Mock：模拟网络延迟与成功响应
      return new Promise<any>((resolve) => {
        setTimeout(() => {
          // 模拟 90% 成功、10% 失败 可按需开启
          // if (Math.random() < 0.1) {
          //   return resolve(Promise.reject(new Error('Mock: 网络繁忙，请稍后重试')))
          // }
          resolve({
            data: {
              code: 200,
              message: "ok",
              data: { id: Date.now(), ...data },
            },
          });
        }, 600);
      });
    }

    return http
      .post("v1/user/join-beta", data)
      .then((response) => {
        // 打印回包内容
        console.log("=== 联系表单提交回包 ===");
        console.log("回包时间:", new Date().toLocaleString("zh-CN"));
        console.log("回包数据:", JSON.stringify(response, null, 2));
        console.log("========================");
        return response;
      })
      .catch((error) => {
        // 打印错误信息
        throw error;
      });
  },
};

export default contactApi;
